export default __webpack_public_path__ + "static/media/loadAnimation.0353b038.gif";